<template>
  <div class="row mt-4">

    <template v-if="quote">
      <div class="col-6 mb-4" v-if="quote">
        <Vehicle :quote="quote" :adminPortalData="adminPortalData" :session="session" title="Your Ordered Vehicle" :showAcceptanceForm="false"/>
      </div>
      <template v-for="replacementQuote in replacementQuotes">
        <div class="col-6 mb-4" v-if="selectedReplacementQuoteId === replacementQuote.quoteID">
          <Vehicle :quote="replacementQuote" :adminPortalData="adminPortalData" :session="session" title="Suggested Alternative Vehicle" :showAcceptanceForm="true"/>
        </div>
      </template>
    </template>

    <template v-else>
      <template v-for="replacementQuote in replacementQuotes">
        <div class="col-12 mb-4" v-if="selectedReplacementQuoteId === replacementQuote.quoteID">
          <Vehicle :quote="replacementQuote" :adminPortalData="adminPortalData" :session="session" title="Suggested Vehicle" :showAcceptanceForm="true" :wide="true"/>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import Vehicle from "./vehicle.vue";

export default {
  name: "vehicle-grid",

  components: { Vehicle },

  props: [
    'session',
    'quote',
    'replacementQuotes',
    'selectedReplacementQuoteId',
    'adminPortalData',
  ],
}
</script>

<style scoped>

</style>
